import { __extends } from "tslib";
import { ImageTexture2D } from "./ImageTexture2D";
var ShadowTexture2D = /** @class */ (function (_super) {
    __extends(ShadowTexture2D, _super);
    function ShadowTexture2D(image) {
        if (image === void 0) { image = null; }
        return _super.call(this, image) || this;
    }
    Object.defineProperty(ShadowTexture2D.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return ShadowTexture2D.assetType;
        },
        enumerable: true,
        configurable: true
    });
    ShadowTexture2D.assetType = "[texture ShadowTexture2D]";
    return ShadowTexture2D;
}(ImageTexture2D));
export { ShadowTexture2D };
import { ShaderBase } from "@awayjs/renderer";
import { _Shader_DepthTexture } from "./DepthTextureCube";
/**
 *
 * @class away.pool._Shader_DepthTexture
 */
var _Shader_ShadowTexture2D = /** @class */ (function (_super) {
    __extends(_Shader_ShadowTexture2D, _super);
    function _Shader_ShadowTexture2D() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    _Shader_ShadowTexture2D.prototype._getFragmentCode = function (targetReg, regCache, sharedRegisters, inputReg) {
        return _super.prototype._getFragmentCode.call(this, targetReg, regCache, sharedRegisters, inputReg) +
            "slt " + targetReg + ".w, " + inputReg + ".z, " + targetReg + ".w\n"; // 0 if in shadow, 1 if out of shadow
    };
    return _Shader_ShadowTexture2D;
}(_Shader_DepthTexture));
export { _Shader_ShadowTexture2D };
ShaderBase.registerAbstraction(_Shader_ShadowTexture2D, ShadowTexture2D);
